import * as React from "react";
import styled from "@emotion/styled";
import { useDropzone } from "react-dropzone";
import { Box, BoxProps } from "@chakra-ui/react";
import { FileUploadOptions } from "../../../types/ui";

  export type FileUploadWrapperProps = FileUploadOptions & BoxProps;
  
  const FileUploadContainer = styled(Box)`
    cursor: pointer;
    border: 2px dashed #eee;
    padding: 25px 10px;
    margin-top: 1rem;
    margin-bottom: 1rem;
    border-radius: 10px;
  
    .fileupload-container {
      outline: none;
    }
  
    .container {
      &:focus {
        outline: none;
      }
    }
  `;
  
  export default function FileUploadWrapper({
    accept,
    maxSize,
    children,
    onUpload,
    isMultiple,
    ...rest
  }: FileUploadWrapperProps) {
    const onDrop = React.useCallback(
      acceptedFiles => {        
        onUpload!(acceptedFiles);
      },
      [onUpload]
    );
    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

    console.log({ isMultiple, accept });
    
    return (
      <FileUploadContainer {...rest}>
        <div {...getRootProps({ className: "fileupload-container" })}>
          <input {...getInputProps()} type='file' multiple={isMultiple === true ? true : false} accept={accept} />
          {typeof children === "function" ? children({ isDragActive }) : children}
        </div>
      </FileUploadContainer>
    );
  }